export const STEPS = {
    GRID: 'grid',
    BATTERY: 'battery',
    ENERGY_PRICES_BUY: 'energyPricesBuy',
    ENERGY_PRICES_SELL: 'energyPricesSell',
    CONFIRMATION: 'confirmation',
};

export const BATTERY_FLOW_RESTRICTIONS = {
    NO_EXPORT: 'noExport',
    NO_IMPORT: 'noImport',
    UNRESTRICTED: 'unrestricted',
};

export const SCHEDULE_VALUE_TYPES = {
    NUMBER: 'number',
    TOGGLE: 'toggle',
};

export const MINIMUM_PERIODIC_FULL_CHARGE_INTERVAL = 2;
export const DEFAULT_PERIODIC_FULL_CHARGE_INTERVAL = 14;
